module.exports = __webpack_public_path__ + "Roboto-MediumItalic.fa183350bf6b814ae552.ttf";


//////////////////
// WEBPACK FOOTER
// /jenkins/jenkins/workspace/apppronosticos_install_s3_dev/~/roboto-fontface/fonts/Roboto/Roboto-MediumItalic.ttf
// module id = ../../../../roboto-fontface/fonts/Roboto/Roboto-MediumItalic.ttf
// module chunks = 5